// external dependencies
import React, { memo } from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'
import { FaChevronDown } from 'react-icons/fa/index.mjs' // https://github.com/react-icons/react-icons/issues/154#issuecomment-438526009
// constants
import { COLORS, FONT_SIZES, MQ } from 'utils/styleHelpers'

// styled components
const Button = styled.button`
	background: ${COLORS.BLUE_LIGHT};
	border-radius: 50px;
	border: none;
	color: ${COLORS.WHITE};
	font-size: ${FONT_SIZES.H4};
	font-weight: bold;
	height: 45px;
	outline: none;
	position: relative;
	text-transform: capitalize;
	width: 175px;

	&:hover {
		opacity: 0.9;
		cursor: pointer;
	}
`

const ButtonContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
	margin: ${({ margin }) => margin};
	width: 100%;

	${MQ.S} {
		justify-content: ${({ alignment }) => alignment};
	}
`

const ArrowSymbol = styled.span`
	position: absolute;
	right: 25px;
	top: 14px;

	svg {
		width: 14px;
	}
`

const propTypes = {
	alignment: string,
	anchorId: string.isRequired,
	anchorText: string.isRequired,
}

const defaultProps = {
	alignment: 'flex-start',
	margin: '0',
}

function AnchorButton({ anchorId, alignment, anchorText, margin }) {
	const handleClick = () => {
		document.getElementById(anchorId).scrollIntoView({
			behavior: 'smooth',
		})
	}

	return (
		<ButtonContainer alignment={alignment} margin={margin}>
			<Button onClick={handleClick}>
				{anchorText}{' '}
				<ArrowSymbol>
					<FaChevronDown />
				</ArrowSymbol>
			</Button>
		</ButtonContainer>
	)
}

AnchorButton.propTypes = propTypes
AnchorButton.defaultProps = defaultProps

export default memo(AnchorButton)
